// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}

ion-menu.md ion-content {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}

ion-menu.md ion-list {
  padding: 20px 0;
}

ion-menu.md ion-note {
  margin-bottom: 30px;
  color: var(--app-note-color, tomato);
}

ion-menu.md ion-list-header,
ion-menu.md ion-note {
  padding-left: 10px;
}

ion-menu.md ion-list#inbox-list {
  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);
}

ion-menu.md ion-list#inbox-list ion-list-header {
  font-size: 22px;
  font-weight: 600;
  min-height: 20px;
}

ion-menu.md ion-list#labels-list ion-list-header {
  font-size: 16px;
  margin-bottom: 18px;
  color: #757575;
  min-height: 26px;
}

ion-menu.md ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 4px;
}

ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
}

ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.md ion-item ion-icon {
  color: var(--app-item-icon-color, #616e7e);
}

ion-menu.md ion-item ion-label {
  font-weight: 500;
}

ion-menu.ios ion-content {
  --padding-bottom: 20px;
}

ion-menu.ios ion-list {
  padding: 20px 0 0 0;
}

ion-menu.ios ion-note {
  line-height: 24px;
  margin-bottom: 20px;
  color: var(--app-note-color, tomato);
}

ion-menu.ios ion-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 50px;
}

ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.ios ion-item ion-icon {
  font-size: 24px;
  color: var(--app-item-icon-color, #73849a);
}

ion-menu.ios ion-list#labels-list ion-list-header {
  margin-bottom: 8px;
}

ion-menu.ios ion-list-header,
ion-menu.ios ion-note {
  padding-left: 16px;
  padding-right: 16px;
}

ion-menu.ios ion-note {
  margin-bottom: 8px;
}

ion-note {
  display: inline-block;
  font-size: 16px;
  color: var(--app-note-color, tomato);
}

ion-item.selected {
  --color: var(--ion-color-primary);
}

/*<=========== Color Texto Giro Servicios=============>*/
.header_color {
  color: rgba(var(--ion-color-primary-rgb), 0.9);
  height: 10%;
}

.note_color {
  color: var(--app-note-color, tomato);
}

.network-chip {
  margin: 10px;
  font-weight: bold;
  width: 80px;
  text-align: center;
}

.user-info {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,2EAAA;AACJ;;AAEA;EACI,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,mBAAA;EACA,oCAAA;AACJ;;AAEA;;EAEI,kBAAA;AACJ;;AAEA;EACI,2DAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,sDAAA;AACJ;;AAEA;EACI,+BAAA;AACJ;;AAEA;EACI,0CAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,mBAAA;EACA,oCAAA;AACJ;;AAEA;EACI,qBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,+BAAA;AACJ;;AAEA;EACI,eAAA;EACA,0CAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;;EAEI,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,eAAA;EACA,oCAAA;AACJ;;AAEA;EACI,iCAAA;AACJ;;AAGA,wDAAA;AAEA;EACI,8CAAA;EACA,WAAA;AADJ;;AAIA;EACI,oCAAA;AADJ;;AAIA;EACI,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AADJ;;AAIA;EACI,aAAA;EACA,uBAAA;EACA,cAAA;AADJ","sourcesContent":["ion-menu ion-content {\n    --background: var(--ion-item-background, var(--ion-background-color, #fff));\n}\n\nion-menu.md ion-content {\n    --padding-start: 8px;\n    --padding-end: 8px;\n    --padding-top: 20px;\n    --padding-bottom: 20px;\n}\n\nion-menu.md ion-list {\n    padding: 20px 0;\n}\n\nion-menu.md ion-note {\n    margin-bottom: 30px;\n    color: var(--app-note-color, tomato); // dinámico\n}\n\nion-menu.md ion-list-header,\nion-menu.md ion-note {\n    padding-left: 10px;\n}\n\nion-menu.md ion-list#inbox-list {\n    border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);\n}\n\nion-menu.md ion-list#inbox-list ion-list-header {\n    font-size: 22px;\n    font-weight: 600;\n    min-height: 20px;\n}\n\nion-menu.md ion-list#labels-list ion-list-header {\n    font-size: 16px;\n    margin-bottom: 18px;\n    color: #757575;\n    min-height: 26px;\n}\n\nion-menu.md ion-item {\n    --padding-start: 10px;\n    --padding-end: 10px;\n    border-radius: 4px;\n}\n\nion-menu.md ion-item.selected {\n    --background: rgba(var(--ion-color-primary-rgb), 0.14);\n}\n\nion-menu.md ion-item.selected ion-icon {\n    color: var(--ion-color-primary);\n}\n\nion-menu.md ion-item ion-icon {\n    color: var(--app-item-icon-color, #616e7e); // dinámico\n}\n\nion-menu.md ion-item ion-label {\n    font-weight: 500;\n}\n\nion-menu.ios ion-content {\n    --padding-bottom: 20px;\n}\n\nion-menu.ios ion-list {\n    padding: 20px 0 0 0;\n}\n\nion-menu.ios ion-note {\n    line-height: 24px;\n    margin-bottom: 20px;\n    color: var(--app-note-color, tomato); // dinámico\n}\n\nion-menu.ios ion-item {\n    --padding-start: 16px;\n    --padding-end: 16px;\n    --min-height: 50px;\n}\n\nion-menu.ios ion-item.selected ion-icon {\n    color: var(--ion-color-primary);\n}\n\nion-menu.ios ion-item ion-icon {\n    font-size: 24px;\n    color: var(--app-item-icon-color, #73849a); // dinámico\n}\n\nion-menu.ios ion-list#labels-list ion-list-header {\n    margin-bottom: 8px;\n}\n\nion-menu.ios ion-list-header,\nion-menu.ios ion-note {\n    padding-left: 16px;\n    padding-right: 16px;\n}\n\nion-menu.ios ion-note {\n    margin-bottom: 8px;\n}\n\nion-note {\n    display: inline-block;\n    font-size: 16px;\n    color: var(--app-note-color, tomato); // dinámico\n}\n\nion-item.selected {\n    --color: var(--ion-color-primary);\n}\n\n\n/*<=========== Color Texto Giro Servicios=============>*/\n\n.header_color {\n    color: rgba(var(--ion-color-primary-rgb), 0.9);\n    height: 10%;\n}\n\n.note_color {\n    color: var(--app-note-color, tomato); // dinámico\n}\n\n.network-chip {\n    margin: 10px;\n    font-weight: bold;\n    width: 80px;\n    text-align: center;\n}\n\n.user-info {\n    display: flex;\n    justify-content: center;\n    margin: 10px 0;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
